/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { RouteComponentProps, Link } from 'react-router-dom'
import classNames from 'classnames/bind'
import { selectPlanScroller } from 'services/PageScroller'
import { ROUTES } from 'constants/routes'
import { Text as TextType } from 'hocs/localization'
import Button from 'elements/Button'
import * as styles from './LoginMeta.scss'

const cx = classNames.bind(styles)

interface IProps extends RouteComponentProps {
  t: TextType,
  setScrollElementId: (elementId: string | null) => void,
}

class LoginMeta extends React.Component<IProps, {}> {

  private goToHomePlans = event => {
    event.preventDefault()
    const { history, setScrollElementId } = this.props

    history.push(ROUTES.home.home)
    setScrollElementId(selectPlanScroller.getElementId())
  }

  public render () {
    const { t } = this.props

    return (
      <React.Fragment>
        <div className={cx(styles.formField, styles.alreadyLogin, styles.buttonWrap)}>
          <span>{t('signUpQuestion')}</span>&nbsp;
          <Button
            styleType='noStyleLink'
            onClick={event => this.goToHomePlans(event)}
          >
            {t('signUp')}
          </Button>
        </div>
        <div className={cx(styles.formField, styles.alreadyLogin)}>
          <Link to={ROUTES.home.forgotPassword}>{t('forgotPasswordLink')}</Link>
        </div>
        <div className={cx(styles.formField, styles.alreadyLogin)}>
          <a href={t('links.doNotSell')} target='_blank'>{t('doNotSell')}</a>
        </div>
      </React.Fragment>
    )
  }
}

export default LoginMeta
